import * as firebase from 'firebase';
import {successRegister} from '../reducers/todo-reducer';

export default  {

	register(values){
		
		return new Promise((resolve,reject)=>{
            let ref = firebase.database().ref('quiero_ser_agente');
          
            let key = ref.push().key;
            console.log("Key: " + key);
            let newRegister = firebase.database().ref('quiero_ser_agente/'+key);

            delete values.messageNombre;
            delete values.messageApePat;
            delete values.messageApeMat;
            delete values.messageCorreo;
            delete values.messageResidencia;
            delete values.open;
            delete values.message;
            delete values.fechNacimiento;
            var now = new Date();

            values.registro = `${now.getDate()}/${now.getMonth()+1}/${now.getFullYear()}`;

            newRegister.set(values,(err)=>{
                if(err === null){

                    //Envio de correo.
                  /*  var message = "<h3>Registro Quiero Ser Agente</h3>"+
                    "<p>"+
                    "<label> Nombre : " +  values.nombre + " " + values.apPat + " " + values.apMat + "</label><br/>"+
                    "<label> Fecha de Nacimiento :  " + values.fechNacimiento + "</label><br/>"+
                    "<label> Teléfono Local : " + values.telLocal + "</label><br/>"+
                    "<label> Teléfono Movil : " + values.telMovil + "</label><br/>"+
                    "<label> Teléfono Oficina : " + values.telOficina + "</label><br/>"+
                    "<label> Correo Electrónico : " + values.email + "</label><br/>"+
                    "<label> País : " + values.pais + "</label><br/>"+
                    "<label> Estado : " + values.estado + "</label><br/>"+
                    "<label> Ciudad : " + values.ciudadResidencia + "</label><br/>"+
                    "<label> Educación : " + values.educacion + "</label><br/>"+
                    "<label> Actividad Actual : " + values.actividadActual + "</label><br/>"+
                    "<label> Institución Educativa : " + values.institucionEducativa + "</label><br/>"+
                    "<label> Ingreso Mensual Requerido : " + values.ingreso_mensual_requerido + "</label>"+
                    "</p>";


                    var bodyRequest ={
                        from: properties().CORREOS_FROM,
                        to:properties().CORREOS_TO,
                        subject:"Registro Quiero Ser Agente",
                        typeBody:"html",
                        message:message
                    };

                    $.ajax({
                        url: properties().CORREO_ENDPOINT, 
                        type: "POST",
                        data:  bodyRequest, 
                        dataType: 'json', 
                        success: function(data,status,req){
                            
                                console.log(req.responseText);
                
                        }, 
                        error: function(data,status,req){
                            
                            console.log("No se logro enviar el correo");
                        }
                    }); */


                    resolve({exito:true,texto:"Agradecemos tu interés en pertenecer a nuestra gran familia GNP, tu registro fue realizado con éxito"});
                }else{
                    console.log(err);

                    resolve({exito:false,texto:"Ocurrio un error al guardar la información."});
                }
            });
           
            
		}).then(successRegister);
    }
}



// WEBPACK FOOTER //
// ./src/apis/todo-api.js